/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiCaseComment
 */
export interface ApiCaseComment {
    /**
     * 
     * @type {string}
     * @memberof ApiCaseComment
     */
    comment?: string;
}

export function ApiCaseCommentFromJSON(json: any): ApiCaseComment {
    return ApiCaseCommentFromJSONTyped(json, false);
}

export function ApiCaseCommentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiCaseComment {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function ApiCaseCommentToJSON(value?: ApiCaseComment | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'comment': value.comment,
    };
}

